import i18next from "i18next";
import { timeFormats } from "../../common/styles";

const formatTime = (
  timeString: string,
  options: Intl.DateTimeFormatOptions,
): string => {
  const [hours, minutes] = timeString.split(":").map(Number);
  return new Date(0, 0, 0, hours, minutes).toLocaleTimeString(
    i18next.language,
    options,
  );
};

export const getTimeDropdownOptions = (
  startTime: string,
  endTime: string,
): { optionId: string; value: string }[] => {
  const startMinutes =
    Number(startTime.split(":")[0]) * 60 + Number(startTime.split(":")[1]);
  const endMinutes =
    Number(endTime.split(":")[0]) * 60 + Number(endTime.split(":")[1]);

  return [
    ...Array(Math.floor((endMinutes - startMinutes) / 30) + 1).keys(),
  ].map((index) => {
    const totalMinutes = startMinutes + index * 30;
    const hours = String(Math.floor(totalMinutes / 60)).padStart(2, "0");
    const minutes = String(totalMinutes % 60).padStart(2, "0");
    const timeString = `${hours}:${minutes}`;
    return {
      optionId: timeString,
      value: formatTime(timeString, timeFormats.default),
    };
  });
};
